import { ComprasVendasFilter, OperacaoTipo } from 'common/genericTypes';
import { descreverIdaOuVoltaDaCompromissada } from './liquidacaoRetornoCompromissada';

export type OpcaoDeFiltroDeSelecao = {
  value: string;
  label: string;
};

export type ItemDeFiltroDaGrid = {
  columnField: string;
  operatorValue?: string;
  value?: unknown;
};

export const rotuloIdaDaCompromissada = descreverIdaOuVoltaDaCompromissada(OperacaoTipo.CompraVendaCompromissada);

export const rotuloVoltaDaCompromissada = descreverIdaOuVoltaDaCompromissada(
  OperacaoTipo.CompraVendaCompromissadaRetorno
);

export const opcoesDeFiltroIdaOuVoltaDaCompromissada: Array<OpcaoDeFiltroDeSelecao> = [
  { value: rotuloIdaDaCompromissada, label: rotuloIdaDaCompromissada },
  { value: rotuloVoltaDaCompromissada, label: rotuloVoltaDaCompromissada },
];

export const traduzirOperadorDeFiltroParaOperationFilterType = (operatorValue?: string): string | undefined => {
  if (operatorValue === 'startsWith') {
    return 'STARTS_WITH';
  }
  if (operatorValue === 'endsWith') {
    return 'ENDS_WITH';
  }
  return operatorValue?.toUpperCase();
};

const formatarValorDoFiltro = (columnField: string, value?: unknown): string | undefined => {
  const valorEmTexto = value?.toString();
  if (!valorEmTexto) {
    return undefined;
  }

  if (columnField === 'DATA_DE_CRIACAO') {
    const parts = valorEmTexto.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }

  return valorEmTexto;
};

export const montarFiltroDeComprasVendasCompromissadas = (
  filter: ItemDeFiltroDaGrid
): ComprasVendasFilter | undefined => {
  const formattedValue = formatarValorDoFiltro(filter.columnField, filter.value);
  if (!formattedValue) {
    return undefined;
  }

  return {
    columnType: filter.columnField.toUpperCase(),
    operationFilterType: traduzirOperadorDeFiltroParaOperationFilterType(filter.operatorValue),
    value: formattedValue,
  };
};
